<template>
  <rest-list-page
    :page-title="pageTitle"
    :fetch-endpoint="fetchEndpoint"
    ref="rest-list-page"
  >
    <template slot="table">
      <rest-list-column-date
        prop="create_time"
        :title="$t('TaskHistoryList_Field_CreateTime')"
        :width="200"
      />

      <rest-list-column-enum
        prop="identifier"
        :title="$t('TaskHistoryList_Field_Identifier')"
        :enum="identifierLabel"
      />

      <rest-list-column prop="info" :title="$t('TaskHistoryList_Field_Info')" />

      <rest-list-column
        v-if="$hasFeature('featureAutomationCampaignExecution')"
        prop="triggered_campaign_id"
        :sortable="false"
        :title="$t('TaskHistoryList_Field_TriggeredCampaignID')"
        :width="180"
      >
        <template slot-scope="scope">
          <router-link
            :to="rowViewCampaign(scope.row)"
            target="_blank"
            v-if="scope.row.triggeredCampaignId"
          >
            {{ scope.row.triggeredCampaignId }}
          </router-link>
          <span v-else>-</span>
        </template>
      </rest-list-column>

      <rest-list-column-enum
        prop="status"
        :title="$t('TaskHistoryList_Field_Status')"
        :enum="statusLabel"
        :width="200"
      />

      <rest-list-column-actions>
        <template slot-scope="scope">
          <rest-list-action-view :route="rowViewRoute(scope.row)" />
          <rest-list-action-delete
            v-if="!readonly"
            :endpoint="rowDeleteEndpoint(scope.row)"
            :name="$t(identifierLabel[scope.row.identifier])"
          />
        </template>
      </rest-list-column-actions>
    </template>
  </rest-list-page>
</template>

<script>
import RestListPage from '@/common/components/rest/RestListPage'
import RestListColumn from '@/common/components/rest/RestListColumn'
import RestListColumnEnum from '@/common/components/rest/RestListColumnEnum'
import RestListColumnDate from '@/common/components/rest/RestListColumnDate'
import RestListActionView from '@/common/components/rest/RestListActionView'
import RestListActionDelete from '@/common/components/rest/RestListActionDelete'
import RestListColumnActions from '@/common/components/rest/RestListColumnActions'
import {
  taskStatusEnum as statusEnum,
  taskIdentifierLabel as identifierLabel,
  taskStatusLabel as statusLabel
} from '@/modules/tasks/enum/TaskRecordEnums'
import { projectEndpoint, projectRoute } from '@/core/helpers'

export default {
  components: {
    RestListPage,
    RestListColumn,
    RestListColumnEnum,
    RestListColumnDate,
    RestListColumnActions,
    RestListActionView,
    RestListActionDelete
  },

  data() {
    return {
      statusEnum,
      identifierLabel,
      statusLabel
    }
  },

  mounted() {
    if (this.$route.query.ids) {
      this.refreshInterval = setInterval(() => {
        this.$refs['rest-list-page'].refresh()
      }, 2500)
    }
  },

  destroyed() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval)
    }
  },

  computed: {
    pageTitle() {
      return this.$t(this.$route.meta.title)
    },

    fetchEndpoint() {
      let endpointParams = {
        sort: '-id',
        id: this.$route.query.ids
      }

      if (this.$hasFeature('featureAutomationCampaignExecution')) {
        endpointParams.expand = 'triggeredCampaignId'
      }

      return projectEndpoint({
        method: 'get',
        url: `task-histories`,
        params: endpointParams
      })
    },

    readonly() {
      return !this.$isRole('admin')
    }
  },

  methods: {
    rowViewRoute(row) {
      return projectRoute({
        name: 'TaskHistoryView',
        query: { id: row.id }
      })
    },

    rowDeleteEndpoint(row) {
      return projectEndpoint({
        method: 'delete',
        url: `task-histories/${row.id}`
      })
    },

    rowViewCampaign(row) {
      return projectRoute({
        name: 'ViewCampaign',
        query: { id: row.triggeredCampaignId }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/tasks/pages/TaskListPage.vue